import React, { Component, useState, useEffect, useRef } from 'react';
import {
    FormContainer, TextFieldElement, PasswordRepeatElement,
    CheckboxElement, PasswordElement, SelectElement
} from 'react-hook-form-mui'

import {
    Container, Grid, TextField, Typography,
    Snackbar, Button, Alert, TextareaAutosize, Stack, Textfield,
    Hidden, InputLabel, Select, MenuItem, FormControl, FormLabel, RadioGroup,
    FormHelperText, FormControlLabel, Radio, Checkbox, Link
} from "@mui/material/";


import { useFormContext } from 'react-hook-form'

import { AccountSelect } from "../components/AccountSelect";

import { useAuth } from "../hooks/useAuth";

import { sendEmailTemplate } from "../firebase";


export const FadingAlert = (props) => {
    const [open, setOpen] = useState(false);
    const errorCountRef = useRef(0);

    useEffect(() => {

        const timer = setTimeout(() => {
            setOpen(false);
        }, 3000);

        return () => {
            clearTimeout(timer);
        };

    }, [props.severity, props.message, open]);

    return (
        open && (
            <Alert severity={props.severity} sx={{ width: '100%' }}>
                {props.children}
            </Alert>
        )
    );
}

export const FieldsContact = () => {
    const { user, claims, accountID } = useAuth();

    return (
        <>
            <Typography>
                <b>Bestellung von:</b> {claims?.name} ({claims?.email})
            </Typography>

            <AccountSelect sx={{ minWidth: 140, maxWidth: 140 }}></AccountSelect>

            <TextFieldElement
                required={claims?.edi === true}
                size="small"
                name="deliveryName"
                label="Lieferung zu Händen von (Name, Vorname)"
                parseError={() => 'Dieses Feld ist erforderlich'}
            />

            {/* Custom cart fields for specific customers */}
            <FieldsCustomCart />

            <TextFieldElement
                required={claims?.edi === true}
                size="small"
                name="costCenter"
                label="Kostenstelle"
                placeholder="*"
                parseError={() => 'Dieses Feld ist erforderlich'}
            />

            <TextFieldElement
                required={claims?.edi === true}
                size="small"
                name="orderNumber"
                label="Bestell-Nummer"
                placeholder="Ihre Bestellnummer"
                parseError={() => 'Dieses Feld ist erforderlich'}
            />

            <FieldMessage></FieldMessage>
        </>
    )
}

/**
 * Custom cart fields component
 * Loads and renders customer-specific cart fields based on user's email
 */
export const FieldsCustomCart = () => {
    const { claims, user } = useAuth();
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadCartConfig = async () => {
            // Only load if user has crt flag enabled
            if (!claims?.crt || !user?.email) {
                setLoading(false);
                return;
            }

            try {
                // Import Firestore functions dynamically to avoid circular dependencies
                const { doc, getDoc } = await import('firebase/firestore');
                const { db } = await import('../firebase');

                // Use user email as document ID
                const configRef = doc(db, 'cart_configs', user.email);
                const configSnap = await getDoc(configRef);

                if (configSnap.exists() && configSnap.data().active) {
                    const configData = configSnap.data();
                    
                    // Transform old format (value) to new format (id) for backward compatibility
                    if (configData.fields?.location?.options) {
                        configData.fields.location.options = configData.fields.location.options.map(option => ({
                            id: option.id || option.value, // Use id if exists, otherwise fallback to value
                            label: option.label
                        }));
                    }
                    
                    setConfig(configData);
                } else {
                    console.warn(`Custom cart config not found or inactive for user: ${user.email}`);
                }
            } catch (err) {
                console.error('Error loading cart config:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        loadCartConfig();
    }, [claims?.crt, user?.email]);

    // Don't render anything if not enabled or still loading
    if (!claims?.crt || loading || !config) {
        return null;
    }

    // Show error as non-blocking info
    if (error) {
        return (
            <Alert severity="info" sx={{ fontSize: '0.875rem' }}>
                Zusatzfelder konnten nicht geladen werden.
            </Alert>
        );
    }

    return (
        <>
            {/* Recipient Email Field */}
            {config.fields?.recipientEmail?.enabled && (
                <TextFieldElement
                    required={config.fields.recipientEmail.required}
                    size="small"
                    name="recipientEmail"
                    label={config.fields.recipientEmail.label}
                    type="email"
                    placeholder={config.fields.recipientEmail.placeholder}
                    parseError={() => 'Bitte geben Sie eine gültige E-Mail-Adresse ein'}
                    helperText={config.fields.recipientEmail.helpText}
                />
            )}

            {/* Location Dropdown Field */}
            {config.fields?.location?.enabled && (
                <SelectElement
                    required={config.fields.location.required}
                    name="location"
                    label={config.fields.location.label}
                    options={config.fields.location.options || []}
                    helperText={config.fields.location.helpText}
                />
            )}

            {/* Custom Text Field 1 */}
            {config.fields?.customField1?.enabled && (
                <TextFieldElement
                    required={config.fields.customField1.required}
                    size="small"
                    name="customField1"
                    label={config.fields.customField1.label}
                    type={config.fields.customField1.type || 'text'}
                    placeholder={config.fields.customField1.placeholder}
                    multiline={config.fields.customField1.multiline}
                    rows={config.fields.customField1.multiline ? 3 : 1}
                    helperText={config.fields.customField1.helpText}
                />
            )}
        </>
    );
}

export const FieldsMagazine = () => {
    const { user, claims, accountID } = useAuth();

    return (
        <TextFieldElement
            label={'Infos zur Zeitschrift'}
            name={'messageMagazine'}
            placeholder="Bitte geben Sie weitere Infos zur Zeitschriften-Bestellung an: z.B. Abo-Art, Abo-Start, Einzelausgabe, ..."
            multiline
            rows={4}
        />
    )
}



export function ResetFormButton() {
    const { reset } = useFormContext()
    return (
        <Button
            onClick={() => {
                reset({})
            }}
        >
            Formular zurücksetzen
        </Button>
    )
}

export const FieldMessage = () => {
    return (
        <TextFieldElement
            label={'Freitext'}
            name={'message'}
            placeholder="Ihre Nachricht"
            multiline
            rows={4}
        />
    )
}

export const ButtonSubmit = () => {

    return (
        <Button
            variant="contained"
            type="submit"
            color="primary"
            size="large"
            sx={{ mt: 3, mb: 2 }}
        >
            Abschicken
        </Button>
    )
}

export const FieldName = () => {
    const { user, claims } = useAuth();

    return (
        <TextFieldElement
            required
            label={'Name'}
            name={'Name'}
            defaultValue={claims?.displayName}
        />
    )
}

export const FormContact = (props) => {
    const { user, claims, accountID } = useAuth();
    const [name, setName] = useState();
    const [error, setError] = useState();
    const [success, setSuccess] = useState();
    const currentRow = props.currentRow || {};

    const handleClose = props.handleClose || (() => { });
    const template = props.template || "debug";

    const onSubmitHandler = (formData) => {
        var data = {};
        data.form = {};
        data.user = {};
        data.db = {};

        data.template = template;


        Object.assign(data.form, formData);
        data.form.accountID = accountID;
    
        Object.assign(data.user, claims);
        Object.assign(data.db, currentRow);

        sendEmailTemplate(data);
        setSuccess("Ihre Nachricht wurde erfolgreich versendet.");
        handleClose();
    }

    return (
        <FormContainer
            onSuccess={onSubmitHandler}

            FormProps={{
                'aria-autocomplete': 'none',
                autoComplete: 'new-password'
            }}>
            <Stack spacing={2}
                // minWidth={'600px'}
                sx={{
                }}
            >

                <Typography>
                    <b>Nachricht von:</b> {claims?.name} ({claims?.email})<br />
                </Typography>


                <TextFieldElement
                    label={'Nachricht'}
                    name={'message'}
                    placeholder="Ihre Nachricht"
                    multiline
                    rows={4}
                />

                <Button type={'submit'} color={'primary'} variant={'contained'}>
                    Abschicken
                </Button>
                {error && <Alert severity="error">{error}</Alert>}
                {success && <Alert severity="success">{success}</Alert>}

            </Stack>
        </FormContainer>
    )
}

export const FormContactAbo = (props) => {
    const { user, claims, accountID } = useAuth();
    const [name, setName] = useState();
    const [error, setError] = useState();
    const [success, setSuccess] = useState();
    const currentRow = props.currentRow || {};

    const handleClose = props.handleClose || (() => { });
    const template = props.template || "aboMessage";

    const onSubmitHandler = (formData) => {
        var data = {};
        data.form = {};
        data.user = {};
        data.db = {};

        data.template = template;

        Object.assign(data.form, formData);
        data.form.accountID = accountID;
        data.form.currentDate = new Date().toLocaleDateString('de-DE');
    
        Object.assign(data.user, claims);
        Object.assign(data.db, currentRow);

        sendEmailTemplate(data);
        setSuccess("Ihre Nachricht wurde erfolgreich versendet.");
        handleClose();
    }

    return (
        <FormContainer
            onSuccess={onSubmitHandler}

            FormProps={{
                'aria-autocomplete': 'none',
                autoComplete: 'new-password'
            }}>
            <Stack spacing={2}
                sx={{
                }}
            >

                <Typography>
                    <b>Nachricht von:</b> {claims?.name} ({claims?.email})<br />
                </Typography>

                <SelectElement
                    label="Art der Nachricht"
                    name="messageType"
                    required
                    options={[
                        { id: 'Nachbestellung', label: 'Nachbestellung' },
                        { id: 'Reklamation', label: 'Reklamation' },
                        { id: 'Abbestellung', label: 'Abbestellung' },
                        { id: 'Sonstiges', label: 'Sonstiges' }
                    ]}
                />

                <TextFieldElement
                    label={'Nachricht'}
                    name={'message'}
                    placeholder="Ihre Nachricht"
                    multiline
                    rows={4}
                    required
                />

                <Button type={'submit'} color={'primary'} variant={'contained'}>
                    Abschicken
                </Button>
                {error && <Alert severity="error">{error}</Alert>}
                {success && <Alert severity="success">{success}</Alert>}

            </Stack>
        </FormContainer>
    )
}

